import Layout from '../views/layout/Layout'

export default {
  path: '/api',
  component: Layout,
  redirect: '/device/supplier',
  name: 'api',
  meta: {title: '开放API', icon: 'API'},
  children: [
    {
      path: 'apiUserPage',
      name: 'apiUserPage',
      component: () => import('@/views/api/apiUserPage/index'),
      meta: {title: '客户列表', icon: 'client-list'}
    },
    {
      path: 'apiUserEdit',
      name: 'apiUserEdit',
      component: () => import('@/views/api/apiUserPage/edit'),
      meta: {title: '录入客户', icon: ''},
      hidden: true
    },
    {
      path: 'InterfacePage',
      name: 'InterfacePage',
      component: () => import('@/views/api/InterfacePage/index'),
      meta: {title: 'API列表', icon: 'API_LIST'}
    },
    {
      path: 'InterfaceEdit',
      name: 'InterfaceEdit',
      component: () => import('@/views/api/InterfacePage/edit'),
      meta: {title: '录入API', icon: ''},
      hidden: true
    },
    {
      path: 'ApiOrderPage',
      name: 'ApiOrderPage',
      component: () => import('@/views/api/ApiOrderAdd/index'),
      meta: {title: '客户订单', icon: 'api_order'}
    },
    {
      path: 'ApiOrderEdit',
      name: 'ApiOrderEdit',
      component: () => import('@/views/api/ApiOrderAdd/edit'),
      meta: {title: '录入订单', icon: ''},
      hidden: true
    },
    {
      path: 'turnover',
      name: 'turnover',
      component: () => import('@/views/api/ApiOrderAdd/turnover'),
      hidden: true
    }
    ,
    {
      path: 'faceSetList',
      name: 'faceSetList',
      component: () => import('@/views/api/faceset/index'),
      meta: {title: 'FaceSet管理', icon: 'faceset'}
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/api.js